// @ts-nocheck
import CustomerProfileSkeleton from 'screens/skeletons/CustomerProfile.skeleton'
import GeneralError from 'screens/errors/GeneralError'
import CustomerProfileController from 'controllers/CustomerProfile.controller'

import ProfileCardContent from 'components/Profile/Customer/ProfileCardContent'
import MinimizedProfileCardContent from 'components/Profile/Customer/MinimizedProfileCardContent'
import CustomerProfileContent from 'components/Profile/Customer/CustomerProfileContent'

const CustomerProfile = ({ 
    isMyProfile,
    id
 }) => {

    const {
        user,
        profile,
        companyUser,
        companyProfile,
        showProfile,
        setShowProfile,
        isLoading,
        error,
        showTab,
        setShowTab,
        handleSubmitForm,
        handleCancelForm,
        isFirstTimeProfile,
        updateProfile,
        updateProfileCustomerProfile,
        updateCompanyProfile,
        updateCompanyProfileCustomerProfile,
    } = CustomerProfileController({ id, isMyProfile });

    return (
        <>
            { isLoading && <CustomerProfileSkeleton /> }
            { error && (
                <GeneralError
                    title={ isMyProfile ? 'Ihr Profil' : 'Fehler' }
                >{ error }</GeneralError>
            ) }
            { user && profile && (
                <>
                    { isMyProfile ? (
                        <>
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <h4 className="page-title">Ihr Profil</h4>
                                    </div>
                                </div>
                            </div>
                            { isFirstTimeProfile && (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="alert alert-info">
                                            Bitte füllen Sie Ihr Profil aus und klicken Sie dann auf "Profil erstellen".
                                        </div>
                                    </div>
                                </div>
                            ) }
                        </>
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">{ user.is_company ? user.company_name : `${user.first_name} ${user.last_name}` }</h4>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-xl-4 col-lg-5">
                            <div className="card text-center">
                                <div className="card-body">
                                    { showProfile === 0 ? (
                                        <ProfileCardContent
                                            user={companyUser ? companyUser : user}
                                            profile={companyProfile ? companyProfile : profile}
                                            isMyProfile={isMyProfile}
                                            isFirstTimeProfile={isFirstTimeProfile} 
                                            handleSubmitForm={handleSubmitForm}
                                            handleCancelForm={handleCancelForm}
                                            showTab={showTab}
                                            setShowTab={setShowTab}
                                            view="customer"
                                        />
                                    ) : (
                                        <div className="inbox-widget text-start">
                                            <MinimizedProfileCardContent
                                                profile={companyProfile ? companyProfile : profile}
                                                profileIndex={0}
                                                setShowProfile={setShowProfile}
                                                user={companyUser ? companyUser : user}
                                            />
                                        </div>
                                    ) }
                                </div>
                            </div>
                            { user && companyUser && (
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="header-title mb-3">Ansprechpartner</h4>
                                        <div className="inbox-widget">
                                            { showProfile === 1 ? (
                                                <div className="text-center">
                                                    <ProfileCardContent
                                                        user={user}
                                                        profile={profile}
                                                        isMyProfile={isMyProfile}
                                                        isFirstTimeProfile={isFirstTimeProfile} 
                                                        handleSubmitForm={handleSubmitForm}
                                                        handleCancelForm={handleCancelForm}
                                                        showTab={showTab}
                                                        setShowTab={setShowTab}
                                                        view="customer"
                                                    />
                                                </div>
                                            ) : (
                                                <MinimizedProfileCardContent
                                                    profileIndex={1}
                                                    profile={profile}
                                                    setShowProfile={setShowProfile}
                                                    user={user}
                                                />
                                            ) }
                                        </div>{" "}
                                    </div>
                                </div>
                            )}
                        </div>{" "}
                        {/* end col*/}
                        <div className="col-xl-8 col-lg-7">
                            <CustomerProfileContent
                                user={(showProfile === 0 && companyUser) ? companyUser : user}
                                profile={(showProfile === 0 && companyProfile) ? companyProfile : profile}
                                privateUser={user}
                                privateProfile={profile}
                                isMyProfile={isMyProfile}
                                isFirstTimeProfile={isFirstTimeProfile}
                                showTab={showTab}
                                setShowTab={setShowTab}
                                handleSubmitForm={handleSubmitForm}
                                handleCancelForm={handleCancelForm}
                                updateProfile={(showProfile === 0 && companyUser) ? updateCompanyProfile : updateProfile}
                                updateProfileCustomerProfile={(showProfile === 0 && companyUser) ? updateCompanyProfileCustomerProfile : updateProfileCustomerProfile}
                            />
                        </div>{" "}
                        {/* end col */}
                    </div>
                </>
            ) }
        </>
    )
}

export default CustomerProfile